import styled from 'styled-components';
import { IconButton } from '../../core/button/IconButton';
import { theme } from '../../utils/theme';

export const StyledBackButton = styled(IconButton)(props => ({
  "& + *": {
    marginRight: theme(props).spacing(1),
  }
})) as typeof IconButton;